<app-tab-grid
  i18n-name
  name="Customers"
  stateKey="UserCustomers"
  gridCssClass="user-customers"
  [columnDefs]="columnDefs"
  [rowData]="model$ | async"
  [showExport]="false"
  (create)="create()"
  (delete)="delete($event)"
></app-tab-grid>
